import { environment } from 'environment';
import { KeycloakOptions } from 'keycloak-angular';

const keycloakOptions: KeycloakOptions = {
    config: {
        url: environment.keycloakSettings.url,
        realm: environment.keycloakSettings.realm,
        clientId: environment.keycloakSettings.clientId,
    },
    initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        token: localStorage.getItem('token') ?? undefined,
        refreshToken: localStorage.getItem('refreshToken') ?? undefined,
        redirectUri: environment.keycloakSettings.homeRedirectUri,
    },
};

export default keycloakOptions;
